import { omitBy, isNil, isUndefined } from 'lodash';
import normalize from './phone-numbers';
import statesCities from 'Components/profile/profile-details/addresses/country_MY.json'

const model = (data: any) => {
  const foundStateObject = !data.state ? undefined : 
    statesCities.STATES.find(s => s.CODE === data.state);

  const stateName = foundStateObject?.NAME;
  const cityName = foundStateObject?.CITIES.find(c => c.CODE === data.city)?.NAME;

  return omitBy({
    fullName: data.fullName,
    primaryEmail: data.email.toLowerCase(),
    primaryAddress: data.addressLine1 ? omitBy({
      type: 'HOME',
      street1: data.addressLine1,
      street2: data.addressLine2,
      city: cityName,
      state: stateName,
      postcode: data.postcode,
      country: data.country,
    }, isNil) : undefined,
    primaryPhone: data.mobilePhone.number
      ? normalize({ ...data.mobilePhone, type: 'MOBILE' }) : undefined,
    identification: data.idNumber
      ? { type: data.idType === 'FOREIGN_ID' ? 'UN' : data.idType, no: data.idNumber } : undefined,
    businessInfo: omitBy({
      businessName: data.businessName,
      registrationNo: data.registrationNo,
    }, v => v === '' || isNil(v)),
    isBusiness: true,
  }, (value) => isUndefined(value))
}

export default model;
